import EvaluationStatesCircle from '../../../../../components/States/EvaluationStatesCircle';
import { Subdimensiones } from '../../../../../interfaces/Evaluations';
import SubdimensionsResAndProc from '../../../utils/SubdimensionLink';

interface ISubdimensionsResAndProc {
    selected_type_indicator: { name: string, id: number },
    selected_dimension: { name: string; id: number; } | null,
    period: string,
    evaluation_subDimension: Subdimensiones[]
    bgColorHeader?: string;
    right: string;
    rightId: string;
}

const MobileTableResAndProc = ({
    evaluation_subDimension,
    bgColorHeader,
    selected_type_indicator,
    selected_dimension,
    period,
    right,
    rightId
}: ISubdimensionsResAndProc) => {
    return (
        <section className='rounded-sm border border-system-light-40'>
            <div className={`${bgColorHeader} h-6 rounded-t-sm`}></div>
            {
                evaluation_subDimension.map((sub, idx) => (
                    <div
                        className='px-3 py-4 border-t-[0.5px] border-system-light-40 flex flex-col gap-4'
                        key={idx}
                    >
                        <div>
                            <h5 className='text-lsmall text-system-light-40'>SUBDIMENSIÓN:</h5>
                            <SubdimensionsResAndProc
                                selected_dimension={selected_dimension}
                                selected_type_indicator={selected_type_indicator}
                                period={period}
                                value={sub.nombre}
                                subdimension={sub}
                                right={right}
                                rightId={rightId}
                            />
                        </div>
                        <div className='flex justify-content gap-2 items-center'>
                            <p className='text-lsmall text-system-light-40'>CANTIDAD DE INDICADORES: </p>
                            <p className='text-bmedium text-system-light-50 '>{sub.indicadores?.length}</p>
                        </div>
                        <div className='flex justify-content gap-2 items-center'>
                            <p className='text-lsmall text-system-light-40'>ESTADO: </p>
                            <EvaluationStatesCircle status={sub.trivalente_subdimension} size={12} />
                        </div>
                    </div>
                ))
            }
        </section>
    )
}

export default MobileTableResAndProc